import React, { useContext } from 'react';
import LayerGroupManager from './LayerGroupManager';
import { MapContext } from '../../contexts/MapContext';

/**
 * Control for thematic overlays (CAR, SIGEF, etc.)
 * Renders multiple LayersControl.Overlay via LayerGroupManager.
 */
export default function ThematicLayersControl({ getStyleForTheme }) {
  const { themeGeometries, activeLayers } = useContext(MapContext);
  return (
    <>
      <LayerGroupManager
        themeGeometries={themeGeometries}
        getStyleForTheme={getStyleForTheme}
        activeLayers={activeLayers}
      />
    </>
  );
}
